import { Typography } from '@mui/material';
import React from 'react';
import OrderWorkunit from 'types/entities/OrderWorkunit';

const OrderworkunitsIDCell = React.memo((row: OrderWorkunit) => (
  <Typography noWrap variant="body2">
    {(row as any).source_order_workunit_id}
  </Typography>
));

export default OrderworkunitsIDCell;
